<vue-page-header appName="{{ 'title.applicationName' | translate | async }}"
  pageTitle="{{ 'title.underUtilizations' | translate | async }}"
  navSection="{{ 'title.alerts' | translate | async }}">
  <app-filter-container>
    <app-poolconsumption-filters></app-poolconsumption-filters>
    <app-underutilization-alert-drawer (success)="getaddPoolconsumption($event)" ></app-underutilization-alert-drawer>
  </app-filter-container>
</vue-page-header>
<app-page-body>
  <!-- <app-error-message >
  </app-error-message> -->
  <vue-section>
    <app-underutilization-table></app-underutilization-table>
  </vue-section>
</app-page-body>
<vue-toast icon="success">
  <span toast-body>
    {{toastMessage}}
  </span>
  <a >
    {{ 'button.viewPoolConsumption' | translate | async }}
  </a>
</vue-toast>